export default __webpack_public_path__ + "static/media/domain-extension-preview.0dff5988.png";